<template>
  <div
    v-if="infoData"
    :class="[infoData.alarm ? 'blink-area' : '', 'notification-block pa-2']"
  >
    <div class="main-info pa-2">
      <h3 class="headline text-xs-center">
        <span class="status-text mr-1 pr-1">
          {{ infoData.state.value | translate }}</span
        >
        <span
          class="status-text mr-1 pr-1"
          v-if="infoData.outputpct !== '0' && infoData.outputpct !== null"
        >
          {{ infoData.outputpct }}%</span
        >
        <span class="status-text" v-if="infoData.output">
          {{ infoData.output.toFixed(1) }}
          {{ infoData.state.unit | translate }}</span
        >
      </h3>
      <h4 id="time">{{ infoData.clock.value }}</h4>
      <div class="pa-2 text-xs-center" flex v-if="infoData.substatesecs.value">
        <p class="mb-0" v-if="infoData.substatesecs.value">
          {{ infoData.substate.value | translate }}
          <span
            v-if="
              infoData.substatesecs.value &&
                infoData.substate.value !== 'lng_substate_21'
            "
          >
            {{ secondCountDown }}</span
          >
          <span
            v-if="
              infoData.substatesecs.value &&
                infoData.substate.value === 'lng_substate_21'
            "
          >
            {{ infoData.substatesecs.value / 10 }}%</span
          >
        </p>
      </div>
      <div
        class="info-icon py-2 px-5 mt-4 text-xs-center"
        v-if="infoMessagesArray.length"
      >
        <!-- {{infoMessagesArray}} v-if="infoMessagesArray.length > 1" -->
        <v-img
          v-if="infoMessagesArray.length > 1"
          class="info-image"
          @click="$emit('openInfoMessages')"
          :src="require('../../assets/Info.png')"
          contain
          height="50"
          width="50"
        ></v-img>
        <p class="mb-0">
          {{ `lng_info_${infoMessagesArray[0].id}` | translate }}
          {{ `${infoMessagesArray[0].argument}` }}
          {{ `${infoMessagesArray[0].unit}` | translate }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomeInfoSection",
  data: () => ({
    infoData: undefined,
    secondCountDown: "",
    infoMessagesArray: [],
    fixedDataArray: [],
    infoMessageInterval: undefined
  }),
  props: {
    controllerData: {
      type: Object,
      default: () => {}
    },
    infoMessages: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    controllerData: function(newVal) {
      this.infoData = newVal;
    }
  },
  async mounted() {
    this.infoData = this.controllerData;
    this.infoData.substate.value !== "lng_substate_21"
      ? this.showCountDown()
      : null;
    this.getInfoMessages();
    this.infoMessagesArray.length > 1 ? this.infoMessageSlider() : null;
  },
  beforeDestroy() {
    clearInterval(this.infoMessageInterval);
  },
  methods: {
    // show countdown in info section
    showCountDown() {
      let that = this;
      let time = this.infoData.substatesecs.value;
      let intervalInstance = setInterval(function() {
        if (--time <= 0) clearInterval(intervalInstance);
        let minutes = Math.floor(time / 60);
        let seconds = time - minutes * 60;
        that.secondCountDown = time - 1 < 0 ? "" : `(${minutes}:${seconds})`;
      }, 1000);
    },
    // make array for info messages
    getInfoMessages() {
      let msgArray = [];
      this.infoMessages.forEach(element => {
        msgArray.push(element);
      });

      let parsedArray = [];
      for (let i = 0, j = 0; i < msgArray.length / 3; i++, j += 3) {
        parsedArray[i] = {
          id: msgArray[j],
          argument: msgArray[j + 1],
          unit: msgArray[j + 2]
        };
      }

      this.infoMessagesArray = parsedArray;
    },
    // info messages array slider
    infoMessageSlider() {
      let that = this;
      that.infoMessageInterval = setInterval(function() {
        let infoMessage = that.infoMessagesArray;
        that.infoMessagesArray.unshift(
          infoMessage.splice(infoMessage.length - 1, 1)[0]
        );
      }, 5000);
    }
  }
};
</script>
<style>
.info-image {
  position: absolute;
  bottom: 0;
  left: 8px;
  top: 60px;
  margin: auto !important;
}
.main-info .headline {
  padding: 0 50px;
}
@media (max-width: 767px) {
  .main-info .headline {
    font-size: 20px !important;
  }
}
</style>
